import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #00000065;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  background: #ffffff;

  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  padding: 32px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* gap: 32px; */
  min-width: 360px;

  .icon {
    position: relative;
    left: 45%;
    height: 12px;
    cursor: pointer;
  }

  .title {
    width: 100%;
    padding-bottom: 14px;
    text-align: center;
    border-bottom: 1px solid #ececec;
  }

  .title p {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }

  .text {
    margin-top: 11px;
    margin-bottom: 16px;
  }

  .text p {
    font-size: 14px;
    font-weight: 400;
    color: #242424;
  }

  .buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    gap: 60px;

    .cancel {
      background-color: transparent;
      border: 1px solid #4d4c4d;
      color: #4d4c4d;
    }
  }
`;
